import React, { useState } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { RowStyle } from 'apps/repository/styles';
import { FileIcon } from 'apps/repository/views/columns/icon';
import { Name } from 'apps/repository/views/columns/name';
import { Message } from 'apps/repository/views/columns/message';
import { LastModified } from 'apps/repository/views/columns/lastModified';
import { Actions } from 'apps/repository/views/columns/actions';

const Row = props => {
  const { fileInfo, last, canContribute, project } = props;
  const file = fileInfo.reference;

  const [isHovering, setIsHovering] = useState(false);
  const handleMouseOver = () => {
    setIsHovering(true);
  };
  const handleMouseOut = () => {
    setIsHovering(false);
  };

  return (
    <RowStyle
      noColorChange={!!file && file.renaming}
      last={last}
      data-intercom-target={props.index === 0 ? 'project-drive' : ''}
      onMouseEnter={handleMouseOver}
      onMouseLeave={handleMouseOut}
    >
      <FileIcon fileInfo={fileInfo} />
      <Name fileInfo={fileInfo} fieldName='newFilename' project={project} />
      <Message fileInfo={fileInfo} project={project} />
      <LastModified fileInfo={fileInfo} />
      {(isHovering || fileInfo.reference?.renaming) && (
        <Actions
          fileInfo={fileInfo}
          canContribute={canContribute}
          project={project}
        />
      )}
    </RowStyle>
  );
};

Row.propTypes = {
  app: PropTypes.object,
  contribFile: PropTypes.object,
  operations: PropTypes.object,
  canContribute: PropTypes.bool,
  last: PropTypes.bool,
  fileInfo: PropTypes.object,
  project: PropTypes.object,
  dragState: PropTypes.object,
  index: PropTypes.number,
};

export default observer(Row);
